import countBy from 'lodash/countBy';
import keys from 'lodash/keys';
import map from 'lodash/map';
import join from 'lodash/join';
import toPairs from 'lodash/toPairs';

export const DiscountsAnalyticsServiceModule = angular
    .module('app.services.data.discountsAnalyticsService', [])
    .service('discountsAnalyticsService', ($window) => {
        return {
            sendDiscountCreateEvent,
            sendDiscountUpdateEvent
        };

        function getScopeAppliesTo(discount) {
            const { scope = { entireStore: true, items: [] } } = discount;
            if (scope.entireStore === true) {
                return 'entire store';
            }
            const groupedItems = countBy(scope.items, 'type');
            const groupedItemKeys = keys(groupedItems);
            const mapped = map(groupedItemKeys, key => `${groupedItems[key]} ${key}`);
            return join(mapped, ' and ');
        }

        function getDiscountAmount(discount) {
            return isDiscountTypeFixed(discount) ?
                `$${discount.fixedPriceReduction}` : `${discount.percentagePriceReduction}%`;
        }

        function getDiscountOfferType(discount) {
            return isDiscountTypeFixed(discount) ? 'dollar' : 'percent';
        }

        function isDiscountTypeFixed(discount) {
            return discount.discountType === 'fixed';
        }

        function convertObjectToString(obj) {
            return toPairs(obj).map(pair => pair.join(':')).join(',');
        }

        function getDiscountUses(discount) {
            return discount.unlimited ? 'Unlimited' : discount.usageLimit;
        }

        function sendDiscountCreateEvent(discount = {}) {
            const discountObject = {
                type: 'create',
                date: encodeURIComponent(discount.createdOn),
                active: discount.isActive,
                discountCode: discount.code,
                status: discount.status.text,
                discountId: discount.id,
                discountLabel: discount.name,
                offerType: getDiscountOfferType(discount),
                amount: getDiscountAmount(discount),
                appliedTo: getScopeAppliesTo(discount),
                duration: discount.duration,
                uses: getDiscountUses(discount)
            };

            const discountCreatedEvent = {
                event: 'discount',
                discount_id: discount.id,
                discount: convertObjectToString(discountObject)
            };
            $window.dataLayer.push(discountCreatedEvent);
        }

        function sendDiscountUpdateEvent(discount) {
            const discountObject = {
                type: 'update',
                date: encodeURIComponent(discount.updatedOn),
                active: discount.isActive,
                discountCode: discount.code,
                status: discount.status.text,
                discountId: discount.id,
                discountLabel: discount.name,
                offerType: getDiscountOfferType(discount),
                amount: getDiscountAmount(discount),
                appliedTo: getScopeAppliesTo(discount),
                duration: discount.duration,
                uses: getDiscountUses(discount)
            };

            const discountUpdatedEvent = {
                event: 'discount',
                discount_id: discount.id,
                discount: convertObjectToString(discountObject)
            };
            $window.dataLayer.push(discountUpdatedEvent);
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/data/discounts-analytics.service.js